export class BrandingTerm {
  id: string;
  searchFor: string;
  replaceWith: string;
  wholeWords: boolean;
  ignoreCase: boolean;
}
